import { AddTask } from '@mui/icons-material';
import { Button, Divider, Stack, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CarPlaceholder from '../../../public/assets/CarPlaceholder.png';
import { OrderTypes } from '../../common/enums/enums';
import WOrderTag from '../WOcomponents/WOrderTag';

export default function VehicleDetail({
  vehicle,
  history,
  isAddEstimateDisabled,
  onNewEstimateClick,
  handleStartDone,
  onAddTechnician,
  enableOrderTagActions,
}) {
  const theme = useTheme();
  const { t } = useTranslation('workOrdersTable');
  const isMediumSizeBreakPoint = useMediaQuery(theme.breakpoints.down('md'));
  const addEstimateDisabled = isAddEstimateDisabled();
  return (
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
      px={0}
      gap={3}
    >
      {!isMediumSizeBreakPoint && (
        <img src={CarPlaceholder} alt="Car Imae" height="60px" />
      )}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'unset', md: 'center' }}
        gap={1}
        flexGrow={1}
        width="1px"
        sx={{ overflow: 'auto', maxHeight: '300px' }}
        p={{
          xs: 2,
          sm: 1,
          lg: 0,
        }}
      >
        {vehicle.relatedOrders.map(order => (
          <WOrderTag
            key={order.vendorOrderId}
            data={order}
            history={history}
            handleStartDone={handleStartDone}
            addTechnician={() => onAddTechnician(order)}
            hasActionsEnabled={enableOrderTagActions}
          />
        ))}
        {!addEstimateDisabled &&
          vehicle.orderType === OrderTypes.RECONDITIONING && (
            <Button
              sx={{
                minWidth: '295px',
                minHeight: '68.95px',
                borderRadius: '4px',
                border: '1px dashed rgba(0, 0, 0, 0.23)',
                order: { xs: 0, sm: 1 },
              }}
              startIcon={<AddTask />}
              onClick={() => onNewEstimateClick(vehicle)}
            >
              {t('vehicleTable.kebab.menu2')}
            </Button>
          )}
      </Stack>
    </Stack>
  );
}
